import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';

const OPCIONES_ESTADO_CULMINACION = [
  { value: '1', label: 'Registrado' },
  { value: '2', label: 'En proceso de certificación' },
  { value: '3', label: 'Certificado entregado' },
  { value: '4', label: 'Planilla pagada' },
];

function ModalCulminacionForm({ isOpen, onClose, onSave, row, opciones }) {
  const [form, setForm] = useState({
    id_requerimiento: '',
    observaciones: '',
    estado: '1',
  });

  useEffect(() => {
    if (!isOpen) return;
    if (row) {
      setForm({
        id_requerimiento: row.id_requerimiento != null ? String(row.id_requerimiento) : '',
        observaciones: row.observaciones || '',
        estado: row.estado != null ? String(row.estado) : '1',
      });
    } else {
      setForm({
        id_requerimiento: '',
        observaciones: '',
        estado: '1',
      });
    }
  }, [isOpen, row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.id_requerimiento) return alert('Seleccione el practicante.');
    const payload = {
      id_requerimiento: Number(form.id_requerimiento),
      observaciones: form.observaciones.trim() || null,
    };
    if (row) {
      payload.id_culminacion = row.id_culminacion;
      payload.estado = Number(form.estado);
    }
    try {
      await onSave(payload);
      onClose(true);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Error al guardar.');
    }
  };

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{row ? 'EDITAR CULMINACIÓN' : 'NUEVO PROCESO DE CULMINACIÓN'}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>
                Practicante (requerimiento): <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="select"
                name="id_requerimiento"
                className="form-control"
                value={form.id_requerimiento}
                onChange={handleChange}
                disabled={!!row && Number(row.estado) !== 1}
              >
                <option value="">Seleccionar</option>
                {(opciones || []).map((o) => (
                  <option key={String(o.id_requerimiento)} value={String(o.id_requerimiento)}>
                    {o.nombre_practicante || o.id_requerimiento}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>Observaciones</Label>
              <Input
                type="textarea"
                name="observaciones"
                className="form-control"
                rows={3}
                value={form.observaciones}
                onChange={handleChange}
              />
            </FormGroup>
            {row && (
              <FormGroup>
                <Label>Estado</Label>
                <Input type="select" name="estado" className="form-control" value={form.estado} onChange={handleChange}>
                  {OPCIONES_ESTADO_CULMINACION.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}
            <FormGroup>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit}>
                  {row ? 'ACTUALIZAR' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalCulminacionForm;
